module.exports = __webpack_public_path__ + "static/media/8100.553d399c.jpg";